import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"


export const requestMemberInformation = async ({ memberId, verbose=false }) => {
    const formData = new FormData()
    formData.append("member_id", memberId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/members/get-member-information", body: formData, verbose: verbose})
}


export const requestMembers = async ({ verbose=false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/members/get-members", verbose: verbose})
}


export const requestMember = async ({ verbose=false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/members/get-member", verbose: verbose})
}


export const requestPaginationSearchMembers = async ({isDefault, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, currentPage, entriesPerPage, sortByIndex, order, isPerma=false, verbose=false}) => {
    const formData = new FormData()
    formData.append("name", name)
    formData.append("name_mode", nameMode)
    formData.append("email", email)
    formData.append("email_mode", emailMode)
    formData.append("character_name", characterName)
    formData.append("character_name_mode", characterNameMode)
    formData.append("server", selectedServer)

    formData.append("page", currentPage)
    formData.append("entries_per_page", entriesPerPage)
    formData.append("sort_by", sortByIndex)
    formData.append("order", order)

    formData.append("default", isDefault)
    formData.append("banned", false)
    formData.append("perma", isPerma)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/members/pagination-search-members", body: formData, verbose: verbose})
}


export const requestPaginationSearchMembersBanned = async ({isDefault, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, currentPage, entriesPerPage, sortByIndex, order, isPerma=false, verbose=false}) => {
    const formData = new FormData()
    formData.append("name", name)
    formData.append("name_mode", nameMode)
    formData.append("email", email)
    formData.append("email_mode", emailMode)
    formData.append("character_name", characterName)
    formData.append("character_name_mode", characterNameMode)
    formData.append("server", selectedServer)

    formData.append("page", currentPage)
    formData.append("entries_per_page", entriesPerPage)
    formData.append("sort_by", sortByIndex)
    formData.append("order", order)

    formData.append("default", isDefault)
    formData.append("banned", true)
    formData.append("perma", isPerma)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/members/pagination-search-members", body: formData, verbose: verbose})
}


export const requestPaginationSearchMembersBannedGame = async ({isDefault, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, currentPage, entriesPerPage, sortByIndex, order, verbose=false}) => {
    const formData = new FormData()
    formData.append("name", name)
    formData.append("name_mode", nameMode)
    formData.append("email", email)
    formData.append("email_mode", emailMode)
    formData.append("character_name", characterName)
    formData.append("character_name_mode", characterNameMode)
    formData.append("server", selectedServer)

    formData.append("page", currentPage)
    formData.append("entries_per_page", entriesPerPage)
    formData.append("sort_by", sortByIndex)
    formData.append("order", order)

    formData.append("default", isDefault)
    formData.append("banned", false)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/members/pagination-search-members", body: formData, verbose: verbose})
}